var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscription-plan-view" },
    [
      _vm.isDialogView
        ? _c(
            "button",
            {
              staticClass: "button-close",
              attrs: { role: "button" },
              on: { click: _vm.closeView },
            },
            [_c("img", { attrs: { src: "/assets/app/class/icon-close.svg" } })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "plan-view-header",
          class: { "with-banner": _vm.isBannerVisisbleWithoutTitle },
        },
        [
          _vm.tableOptions.show_title && !_vm.pricingTable
            ? _c("div", { staticClass: "pricing-table-title" }, [
                _c("h2", { staticClass: "view-title" }, [
                  _vm._v("Get ReadTheory for your school"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "description" }, [
                  _vm._v(
                    "Includes all our advanced features for schools, teachers, and students"
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.tableOptions.banner_image_url && !_vm.pricingTable
            ? _c("div", { staticClass: "pricing-table-title" }, [
                _c("img", {
                  staticClass: "pricing-custom-banner",
                  attrs: { src: _vm.tableOptions.banner_image_url },
                }),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "plan-view-main" },
        _vm._l(_vm.subscriptionPlans, function (pricingPlan, pIdx) {
          return _vm.isPlanVisible(pricingPlan.type, pIdx)
            ? _c(
                "div",
                {
                  key: pIdx,
                  staticClass: "subscription-card",
                  class: { "custom-plan": _vm.plansCount <= 3 },
                },
                [
                  _vm.isPopularPlan(pricingPlan.identifier)
                    ? _c("img", {
                        staticClass: "icon-popular",
                        attrs: { src: "/assets/app/class/icon-popular.svg" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "subscription-header" }, [
                    _c("img", {
                      staticClass: "plan-icon",
                      attrs: { src: _vm.pricingPlanIcon(pricingPlan) },
                    }),
                    _vm._v(" "),
                    _c("h2", { staticClass: "subscription-title" }, [
                      _vm._v(_vm._s(_vm.pricingPlanName(pricingPlan))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "subscription-content",
                      class: {
                        inifinte: _vm.isCustomPlan(pricingPlan.type),
                        "slide-content": _vm.isSliderView,
                      },
                    },
                    [
                      _c("div", { staticClass: "subscription-price" }, [
                        !_vm.isCustomPlan(pricingPlan.type)
                          ? _c(
                              "div",
                              { staticClass: "current-amount-wrapper" },
                              [
                                _c("span", { staticClass: "price-symbol" }, [
                                  _vm._v("$"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "amount-value" }, [
                                  _vm._v(_vm._s(_vm.getAmount(pricingPlan))),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "price-symbol" }, [
                                  _vm._v("/ " + _vm._s(_vm.planAmountSuffix)),
                                ]),
                              ]
                            )
                          : _c("img", {
                              staticClass: "icon-infinite",
                              attrs: {
                                src: "/assets/app/class/icon-infinite-rocket.svg",
                              },
                            }),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "plan-descripion" }, [
                        _vm._v(_vm._s(_vm.planDescription(pricingPlan))),
                      ]),
                      _vm._v(" "),
                      !_vm.isSliderView
                        ? _c(
                            "div",
                            {
                              staticClass: "subscription-action",
                              class: {
                                popular: pricingPlan.identifier === "2",
                              },
                            },
                            [
                              _c(
                                "primary-button",
                                {
                                  staticClass: "pay-with-card-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleUpgradePlan(pricingPlan)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "btn-action-title" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.pricingActionTitle(
                                            pricingPlan.type
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.upgradingStatus &&
                                  _vm.upgradingStatus[pricingPlan.identifier]
                                    ? _c("div", {
                                        staticClass: "loading-spinner",
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isCustomPlan(pricingPlan.type)
                                    ? _c("a", {
                                        staticClass: "email-link",
                                        attrs: {
                                          href: "mailto:support@readtheory.org?subject=Quote%20for%20our%20district",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.isFreePlan(pricingPlan.type)
                                ? _c(
                                    "primary-button",
                                    {
                                      staticClass: "quote-button",
                                      staticStyle: { "margin-top": "12px" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openQuoteForm(pricingPlan)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            Contact Sales\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "features-list" },
                        _vm._l(
                          _vm.pricingFeatures(pricingPlan),
                          function (featureDesc, idx) {
                            return _c("li", { key: idx }, [
                              _c("img", {
                                attrs: {
                                  src: "/assets/app/class/icon-check-blue.svg",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "feature-description" },
                                [_vm._v(_vm._s(featureDesc))]
                              ),
                            ])
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _vm.isSliderView
                        ? _c(
                            "div",
                            {
                              staticClass: "subscription-action",
                              class: {
                                free:
                                  _vm.isLoggedIn &&
                                  _vm.isFreePlan(pricingPlan.type),
                                popular: pricingPlan.identifier === "2",
                              },
                            },
                            [
                              _c(
                                "primary-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleUpgradePlan(pricingPlan)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "btn-action-title" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.pricingActionTitle(
                                            pricingPlan.identifier
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.upgradingStatus &&
                                  _vm.upgradingStatus[pricingPlan.identifier]
                                    ? _c("div", {
                                        staticClass: "loading-spinner",
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isCustomPlan(pricingPlan.type)
                                    ? _c("a", {
                                        staticClass: "email-link",
                                        attrs: {
                                          href: "mailto:support@readtheory.org?subject=Quote%20for%20our%20district",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.priceYearly &&
                              !_vm.isFreePlan(pricingPlan.type)
                                ? _c(
                                    "p",
                                    { staticClass: "yearly-disclaimer" },
                                    [_vm._v("*when billed annually")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _vm.clickedGetQuote
        ? _c("subscription-quote-form", {
            attrs: { "price-id": _vm.currPriceId },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }